module.exports = __webpack_public_path__ + "img/Oracle.ba60e4dc.png";